// Type for YAML-based URLs
export interface YamlUrl {
  id: string;
  name: string;
  pathname: string;
}

export default class Url {
  id: string;
  name: string;
  pathname: string;

  constructor(url: YamlUrl | string) {
    // Handle string input (for simple cases)
    if (typeof url === "string") {
      this.id = url;
      this.name = url;
      this.pathname = url;
      return;
    }

    this.id = url.id!;
    this.name = url.name!;
    this.pathname = url.pathname!;
  }
}
